/* Balkonwunder launch: 2/3/4 modules, inverter, fixed 5 m AC cable. */
(() => {
  'use strict';
  class BWProduct extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      try {
        this.product = JSON.parse(this.querySelector('[data-bw-product-data]').textContent);
        this.form = this.querySelector('form');
        this.nativeSelect = this.querySelector('[data-bw-native-variant]');
        this.moduleInputs = [...this.querySelectorAll('[data-bw-modules]')];
        this.button = this.querySelector('[data-bw-submit]');
        this.error = this.querySelector('[data-bw-error]');
        this.demo = this.dataset.demo === 'true' || !this.nativeSelect;
        this.money = new Intl.NumberFormat(this.dataset.locale || 'de-DE', { style: 'currency', currency: this.dataset.currency || 'EUR' });
        this.variants = (this.product.variants || []).filter(variant => this.isLaunchVariant(variant));
        const params = new URL(location.href).searchParams;
        const requestedId = params.get('variant');
        const requestedModule = params.get('bw_modules');
        const initial = this.variants.find(v => String(v.id) === requestedId) || this.variants.find(v => v.options[0] === requestedModule) || this.variants.find(v => String(v.id) === String(this.nativeSelect?.value)) || this.variants.find(v => v.available) || this.variants[0];
        const moduleChoice = ['2 Module', '3 Module', '4 Module'].includes(requestedModule) ? requestedModule : initial?.options[0] || '2 Module';
        this.selectModules(moduleChoice);
        this.querySelectorAll('[data-bw-gallery-step]').forEach(button => button.addEventListener('click', () => this.stepImage(Number(button.dataset.bwGalleryStep))));
        this.form.addEventListener('change', event => {
          if (event.target === this.nativeSelect) {
            const selected = this.variants.find(v => String(v.id) === String(this.nativeSelect.value));
            if (selected) this.selectModules(selected.options[0]);
          }
          this.update();
        });
        this.form.addEventListener('input', event => { if (event.target.matches('[data-bw-power-price]')) this.updateSavings(); });
        this.form.addEventListener('submit', event => this.submit(event));
        this.querySelectorAll('[data-bw-thumb]').forEach(button => button.addEventListener('click', () => this.showImage(button)));
        this.dataset.ready = 'true';
        this.update(false);
      } catch (error) {
        console.warn('Balkonwunder: Konfigurator konnte nicht geladen werden.', error);
        // The filtered native variant select still provides a standard Shopify product form.
        if (this.dataset.demo === 'true' || !this.nativeSelect?.options.length) this.button?.setAttribute('disabled', '');
      }
    }
    isLaunchVariant(variant) {
      if (!['2 Module', '3 Module', '4 Module'].includes(variant.options?.[0])) return false;
      const names = this.product.options_with_values?.map(option => option.name) || this.product.options || [];
      return variant.options.slice(1).every((value, index) => {
        const name = String(names[index + 1] || '').toLowerCase();
        if (name.includes('system')) return value === 'Wechselrichter';
        if (/schuko|schucko|kabel/.test(name)) return ['5 m', '5m', '5 Meter'].includes(value);
        return false;
      });
    }
    selectModules(value) {
      this.moduleInputs.forEach(input => { input.checked = input.value === value; });
    }
    selectedModule() {
      return this.moduleInputs.find(input => input.checked)?.value || '2 Module';
    }
    imageForModules(kind) {
      const count = Number.parseInt(this.selectedModule(), 10);
      const word = ({ 2: 'Two', 3: 'Three', 4: 'Four' })[count] || 'Two';
      return this.dataset[(kind === 'panels' ? 'panels' : 'image') + word];
    }
    update(updateUrl = true) {
      const choice = this.selectedModule();
      this.variant = this.variants.find(v => v.options[0] === choice && v.available) || this.variants.find(v => v.options[0] === choice);
      const shipping = parseInt(choice, 10) >= 3 ? 10207 : 5557;
      const setPrice = Number(this.variant?.price || 0);
      this.querySelector('[data-bw-shipping-note]').textContent = ''; 
      this.querySelector('[data-bw-price]').textContent = this.variant ? this.money.format(setPrice / 100) : 'Zurzeit nicht verfügbar';
      this.querySelector('[data-bw-total]').textContent = this.variant ? this.money.format(setPrice / 100) : 'Zurzeit nicht verfügbar';
      if (this.nativeSelect) this.nativeSelect.value = this.variant?.id || '';
      this.button.disabled = this.demo || this.busy || !this.variant?.available;
      this.querySelector('[data-bw-submit-label]').textContent = this.demo ? 'Zurzeit nicht verfügbar' : !this.variant?.available ? 'Zurzeit nicht verfügbar' : 'In den Warenkorb';
      const descriptions = [
        choice + ' · Lionshee LS-SP240 · flexibel & mit Befestigungsösen',
        'Mikrowechselrichter Lionshee LS-800Mi',
        'Edelstahl-Kabelbinder gemäß Set-Lieferumfang',
        'Schuko-Anschlusskabel · 5 m',
        '3 Erklärvideos: Aufbau, MaStR, App & WLAN',
        'Persönlicher Support über WhatsApp'
      ];
      if (parseInt(choice, 10) === 3) descriptions.push('1 MC4-Y-Kabelpaar für den Wechselrichter');
      if (parseInt(choice, 10) === 4) descriptions.push('2 MC4-Y-Kabelpaare für den Wechselrichter');
      this.querySelector('[data-bw-package-list]').replaceChildren(...descriptions.map(text => { const li = document.createElement('li'); li.textContent = text; return li; }));
      this.querySelector('[data-bw-selected-thumb]').src = this.imageForModules('kit');
      this.querySelector('[data-bw-panels-thumb]').src = this.imageForModules('panels');
      this.showImage(this.querySelector('[data-bw-thumb="selected"]'));
      this.updateSavings();
      if (updateUrl && this.variant && !this.demo && !this.closest('.bw-demo-fold')) {
        const url = new URL(location.href);
        url.searchParams.set('variant', this.variant.id);
        url.searchParams.delete('bw_modules');
        url.searchParams.delete('bw_system');
        history.replaceState({}, '', url);
      }
    }
    updateSavings() {
      const calculator = this.querySelector('[data-bw-savings]');
      if (!calculator) return;
      const count = Number.parseInt(this.selectedModule(), 10);
      const price = Number(calculator.querySelector('[data-bw-power-price]')?.value);
      const sun = calculator.querySelector('input[name^="bw-sun-"]:checked')?.value || 'high';
      const watts = Number(calculator.dataset.moduleWatts || 240);
      const yields = { low: Number(calculator.dataset.yieldLow || 500), normal: Number(calculator.dataset.yieldNormal || 750), high: Number(calculator.dataset.yieldHigh || 950) };
      const selfUse = Number(calculator.dataset.selfUse || 75) / 100;
      const used = (count * watts / 1000) * yields[sun] * selfUse;
      const annual = used * (price / 100);
      const year = calculator.querySelector('[data-bw-savings-year]');
      const month = calculator.querySelector('[data-bw-savings-month]');
      const payback = calculator.querySelector('[data-bw-payback]');
      if (!Number.isFinite(annual) || annual <= 0 || price < 15 || price > 80) {
        year.textContent = 'Eingabe prüfen'; month.textContent = '–'; payback.textContent = '–'; return;
      }
      const roundFive = value => Math.max(5, Math.round(value / 5) * 5);
      const low = roundFive(annual * .88);
      const high = Math.max(low + 5, roundFive(annual * 1.12));
      const money = value => new Intl.NumberFormat(this.dataset.locale || 'de-DE', { style: 'currency', currency: this.dataset.currency || 'EUR', maximumFractionDigits: 0 }).format(value);
      year.textContent = 'ca. ' + money(roundFive(annual)) + '*';
      month.textContent = 'ca. ' + money(annual / 12);
      if (this.variant) {
        const shippingCost = Number(count >= 3 ? calculator.dataset.shippingLarge : calculator.dataset.shippingTwo);
        const setPrice = (Number(this.variant.price || 0) + shippingCost) / 100;
        const number = value => value.toLocaleString(this.dataset.locale || 'de-DE', { maximumFractionDigits: 1 });
        payback.textContent = number(setPrice / annual) + ' Jahre*';
      } else payback.textContent = '–';
      calculator.querySelector('[data-bw-savings-formula]').textContent = count + ' × ' + watts + ' W / 1000 × ' + yields[sun] + ' kWh/kWp × ' + Math.round(selfUse * 100) + ' % Eigenverbrauch = ca. ' + Math.round(used) + ' selbst genutzte kWh. × ' + (price / 100).toLocaleString('de-DE', { minimumFractionDigits: 2 }) + ' €/kWh = ca. ' + money(annual) + ' pro Jahr.';
    }
    stepImage(step) {
      const thumbs = [...this.querySelectorAll('[data-bw-thumb]')];
      const current = thumbs.findIndex(b => b.getAttribute('aria-pressed') === 'true');
      this.showImage(thumbs[(current + step + thumbs.length) % thumbs.length]);
    }
    showImage(button) {
      if (!button) return;
      const selected = button.dataset.bwThumb === 'selected';
      const panels = button.dataset.bwThumb === 'panels';
      const url = selected ? this.imageForModules('kit') : panels ? this.imageForModules('panels') : button.dataset.bwThumb;
      if (!url) return;
      const main = this.querySelector('.bw-gallery-main');
      main.removeAttribute('srcset');
      main.src = url;
      main.alt = selected ? this.selectedModule() + ' mit Mikrowechselrichter, Schuko-Kabel und Befestigungsmaterial · Produktillustration' : panels ? this.selectedModule() + ' im Detail · Produktillustration' : button.getAttribute('aria-label');
      const aiNote = this.querySelector('.bw-main-image > .bw-ai-note');
      if (aiNote) aiNote.hidden = button.dataset.bwAi !== 'true';
      const photoNote = this.querySelector('[data-bw-image-note]');
      if (photoNote) photoNote.textContent = button.dataset.bwPhoto === 'real' ? 'Praxisfoto · Beispiel einer montierten Anlage' : selected || panels ? 'Produktillustration · Lieferumfang gemäß Auswahl' : 'Produktdetail · Lieferumfang gemäß Auswahl';
      this.querySelectorAll('[data-bw-thumb]').forEach(el => el.setAttribute('aria-pressed', String(el === button)));
    }
    async submit(event) {
      event.preventDefault();
      if (this.demo || this.busy || !this.form.reportValidity() || !this.variant?.available) return;
      this.error.textContent = '';
      this.busy = true;
      this.button.disabled = true;
      this.button.setAttribute('aria-busy', 'true');
      this.querySelector('[data-bw-submit-label]').textContent = 'Wird hinzugefügt …';
      try {
        const root = this.dataset.root || window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, credentials: 'same-origin', body: JSON.stringify({ items: [{ id: this.variant.id, quantity: 1 }] }) });
        const result = await response.json();
        if (!response.ok) throw new Error(typeof result.description === 'string' ? result.description : 'Die Auswahl konnte nicht hinzugefügt werden.');
        location.assign(this.dataset.cartUrl || root + 'cart');
      } catch (error) {
        this.error.textContent = (error.message || 'Die Anfrage konnte nicht abgeschlossen werden.') + ' Bitte prüfe den Warenkorb vor einem erneuten Versuch.';
        const link = document.createElement('a');
        link.href = this.dataset.cartUrl || '/cart';
        link.textContent = ' Warenkorb öffnen';
        link.style.textDecoration = 'underline';
        this.error.append(link);
        this.error.focus();
        this.busy = false;
        this.button.removeAttribute('aria-busy');
        this.update(false);
      }
    }
  }
  if (!customElements.get('bw-product')) customElements.define('bw-product', BWProduct);
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-bw-site-menu][open]').forEach(menu => {
      if (event.target.closest('[data-bw-site-menu]') !== menu || event.target.closest('.bw-menu-panel a')) menu.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('[data-bw-site-menu][open]').forEach(menu => {
      menu.open = false;
      menu.querySelector('summary')?.focus();
    });
  });

  function initializeComparisons(root = document) {
    root.querySelectorAll('[data-bw-comparison]').forEach(section => {
      if (section.dataset.bwReady) return;
      section.dataset.bwReady = 'true';
      const tabs = section.querySelector('[data-bw-compare-tabs]');
      const buttons = [...tabs.querySelectorAll('[data-bw-compare-tab]')];
      const panels = [...section.querySelectorAll('[data-bw-compare-panel]')];
      const mobile = window.matchMedia('(max-width: 749px)');
      let selected = 'flex';
      function update() {
        tabs.hidden = !mobile.matches;
        buttons.forEach(button => {
          const active = button.dataset.bwCompareTab === selected;
          button.setAttribute('aria-selected', String(active));
          button.tabIndex = active ? 0 : -1;
        });
        panels.forEach(panel => {
          panel.hidden = mobile.matches && panel.dataset.bwComparePanel !== selected;
          if (mobile.matches) {
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('aria-labelledby', buttons.find(button => button.dataset.bwCompareTab === panel.dataset.bwComparePanel).id);
            panel.tabIndex = 0;
          } else {
            panel.removeAttribute('role');
            panel.removeAttribute('aria-labelledby');
            panel.removeAttribute('tabindex');
          }
        });
      }
      buttons.forEach((button, index) => {
        button.addEventListener('click', () => { selected = button.dataset.bwCompareTab; update(); });
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (index + (event.key === 'ArrowRight' ? 1 : -1) + buttons.length) % buttons.length;
          selected = buttons[next].dataset.bwCompareTab;
          update();
          buttons[next].focus();
        });
      });
      mobile.addEventListener('change', update);
      update();
    });
  }

  initializeComparisons();
  document.addEventListener('shopify:section:load', event => {
    initializeComparisons(event.target);
  });
})();
